import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Header from '../../../../components/Header';
import NavigationTabsDoctor from './navigationTabsDoctor';
import DoctorForm from '../createDoctor/doctorForm';
import { getCities } from '../../../../../services/vendor';
import { hasPermission, newObjectCreater } from '../../../../../utils/controller';
import { master_data } from '../../../../../store/action/master';
import { useDispatch, useSelector } from 'react-redux';
import DeleteModal from '../../../components/deleteModal';
import ConfirmationModal from '../../../../../component/modal/ConfirmationModal';
import {
	changeDoctorStatus,
	createDoctor,
	deleteDoctor,
	getDoctorDetail,
	updateDoctor,
} from '../../../../../services/doctors';

const DoctorDetails = () => {
	const suburl = localStorage.getItem('suburl');
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const navigate = useNavigate();
	const param = useParams();
	const dispatch = useDispatch();
	const id = param?.id;
	const [cityList, setCityList] = useState([]);
	const [isLoader, setLoader] = useState(false);
	const [isClone, setIsClone] = useState(false);
	const [isMarkAsStatusModel, setIsMarkAsStatusModel] = useState(false);
	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const [isNotEdit, setIsNotEdit] = useState(true);
	const [isLoading, setLoading] = useState(false);
	const [isEditProfile, setIsEditProfile] = useState(false);
	const [activeTab, setActiveTab] = useState('Information');
	const [activeFormTab, setActiveFormTab] = useState('Other Details');
	const [projectTitle, setProjectTitle] = useState('Doctor Details');
	const [errors, setError] = useState({});
	const [doctorData, setDoctorData] = useState({
		basicDetails: {
			doctor_type_id: null,
			doctor_name: '',
			profile_url: null,
			business_name: '',
			doctor_display_name: '',
			doctor_email: '',
			doctor_phone_mobile: '',
			doctor_phone_work: '',
			status: 0,
		},
		othersDetails: {
			registration_number: '',
			is_enable_portal: false,
		},
		address: {
			attention: '',
			country_id: '',
			street_1: '',
			street_2: '',
			city_id: null,
			state_id: null,
			zip_code: '',
		},
		doctorRemark: {
			remark_text: '',
		},
	});
	const [doctorDocs, setDoctorDocs] = useState({
		registration_doc: null,
	});

	async function getDoctorDetails() {
		try {
			var { doctor } = await getDoctorDetail(id);
			setDoctorData({
				basicDetails: {
					doctor_type_id: doctor?.doctor_type_id ? Number(doctor?.doctor_type_id) : null,
					doctor_name: doctor?.name,
					business_name: doctor?.business_name,
					doctor_display_name: doctor?.display_name,
					doctor_email: doctor?.email,
					doctor_phone_mobile: doctor?.mobile,
					doctor_phone_work: doctor?.phone,
					profile_url: doctor?.profile_url || null,
					status: doctor?.status,
				},
				othersDetails: {
					registration_number: doctor?.registration_number,
					is_enable_portal: doctor?.is_enable_portal,
				},
				address: {
					attention: doctor?.attention,
					country_id: doctor?.country_id,
					street_1: doctor?.street_1,
					street_2: doctor?.street_2,
					city_id: doctor?.city_id,
					state_id: doctor?.state_id,
					zip_code: doctor?.zipcode,
				},
				doctorRemark: {
					remark_text: doctor?.remarks,
				},
			});
			setDoctorDocs({
				registration_doc:
					doctor?.documents.filter((data) => data.type === 'registration_doc') === undefined
						? null
						: doctor?.documents.filter((data) => data.type === 'registration_doc')[0],
			});
		} catch (err) {
			toast.error(err.message || 'something went wrong!');
		}
	}

	const checkValidation = () => {
		var error = { ...errors };
		if (
			!doctorData.othersDetails.registration_number ||
			doctorData.othersDetails.registration_number === undefined ||
			doctorData.othersDetails.registration_number === ''
		) {
			setActiveFormTab('Other Details');
			error.registration_number =
				'Please enter registration number(As Per State Medical Council) in the field';
		} else {
			delete error.registration_number;
		}
		if (
			!doctorData.basicDetails.doctor_name ||
			doctorData.basicDetails.doctor_name === undefined ||
			doctorData.basicDetails.doctor_name === ''
		) {
			error.doctor_name = 'Please enter doctor name in the field';
		} else {
			delete error.doctor_name;
		}
		if (
			!doctorData.basicDetails.business_name ||
			doctorData.basicDetails.business_name === undefined ||
			doctorData.basicDetails.business_name === ''
		) {
			error.business_name = 'Please enter business name in the field';
		} else {
			delete error.business_name;
		}
		if (
			!doctorData.basicDetails.doctor_display_name ||
			doctorData.basicDetails.doctor_display_name === undefined ||
			doctorData.basicDetails.doctor_display_name === ''
		) {
			error.doctor_display_name = 'Please select valid doctor display name in the list';
		} else {
			delete error.doctor_display_name;
		}
		if (Object.keys(error).length > 0) {
			setError(error);
			return true;
		} else {
			return false;
		}
	};

	async function handleBulkDelete() {
		try {
			var body = JSON.stringify({
				ids: [id],
			});
			await deleteDoctor(body);
			toast.success('Customer Deleted Successfully.');
			setIsDeleteModalOpen(false);
			navigate(`/user/${suburl}/doctors`);
		} catch (error) {
			toast.error(error?.message || 'Something went wrong');
		}
	}

	const getModalContent = () => {
		return (
			<div>
				<p
					style={{ fontWeight: '600' }}
					className="ConfirmationText"
				>
					Are you sure you want to mark doctor as{' '}
					{doctorData.basicDetails.status === 1 ? 'Inactive' : 'Active'}?
				</p>
				<div
					style={{
						padding: '0px 10px',
					}}
				>
					{`1.${doctorData.basicDetails.doctor_name}`}
				</div>
			</div>
		);
	};

	const getModalTitle = () => {
		if (doctorData.basicDetails.status === 1) {
			return 'Mark as Inactive Doctor';
		} else if (doctorData.basicDetails.status === 2) {
			return 'Mark as Active Doctor';
		}
		return 'Confirm Action';
	};

	async function handleIsActiveStatus(status) {
		try {
			const formbody = {
				ids: [id],
				status: status,
			};
			setLoader(true);
			await changeDoctorStatus(formbody);
			getDoctorDetails();
			toast.success('Status Changes Successfully');
			setIsMarkAsStatusModel(false);
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setLoader(false);
		}
	}

	const handleCloneDoctor = async (status) => {
		const checkError = checkValidation();
		if (checkError) {
			toast.error('Please fill all mandatory fields before saving');
		} else {
			setLoading(true);
			const formData = new FormData();
			const doctorObj = {
				doctor_type_id: doctorData.basicDetails.doctor_type_id,
				status: status,
				name: doctorData.basicDetails.doctor_name,
				display_name: doctorData.basicDetails.doctor_display_name,
				business_name: doctorData.basicDetails.business_name,
				email: doctorData.basicDetails.doctor_email,
				phone: doctorData.basicDetails.doctor_phone_work,
				mobile: doctorData.basicDetails.doctor_phone_mobile,

				is_enable_portal: doctorData.othersDetails.is_enable_portal,
				registration_number: doctorData.othersDetails.registration_number,

				attention:
					doctorData.address.attention !== '' && doctorData.address.attention !== null
						? doctorData.address.attention
						: '',
				country_id:
					doctorData.address.country_id !== '' && doctorData.address.country_id !== null
						? doctorData.address.country_id
						: '',
				city_id:
					doctorData.address.city_id !== '' && doctorData.address.city_id !== null
						? doctorData.address.city_id
						: '',
				street_1:
					doctorData.address.street_1 !== '' && doctorData.address.street_1 !== null
						? doctorData.address.street_1
						: '',
				street_2:
					doctorData.address.street_2 !== '' && doctorData.address.street_2 !== null
						? doctorData.address.street_2
						: '',
				state_id:
					doctorData.address.state_id !== '' && doctorData.address.state_id !== null
						? doctorData.address.state_id
						: '',
				zipcode:
					doctorData.address.zip_code !== '' && doctorData.address.zip_code !== null
						? doctorData.address.zip_code
						: '',
			};
			for (const key in doctorObj) {
				formData.append(key, doctorObj[key]);
			}

			if (doctorData.doctorRemark.remark_text) {
				formData.append('remarks', doctorData.doctorRemark.remark_text);
			}

			if (doctorDocs.registration_doc) {
				formData.append('registration_doc', doctorDocs.registration_doc);
			}
			if (doctorData.basicDetails.profile_url) {
				formData.append('profile_url', doctorData.basicDetails.profile_url);
			}

			try {
				const res = await createDoctor(formData);
				if (res?.success) {
					toast.success(res?.message);
					navigate(`/user/${suburl}/doctors`);
				} else {
					toast.error(res?.message || 'Something went wrong');
				}
			} catch (error) {
				toast.error(error?.message || 'Something went wrong');
			} finally {
				setLoading(false);
			}
		}
	};

	async function getCity(stateId) {
		try {
			var body = {
				state_id: Number(stateId),
			};
			var res = await getCities(body);
			if (res?.success) {
				var cities = newObjectCreater(res?.data);
				setCityList(cities);
			}
		} catch (error) {
			toast.error(error);
		}
	}
	useEffect(() => {
		dispatch(master_data());
	}, [dispatch]);

	useEffect(() => {
		getCity(doctorData.address.state_id);
	}, [doctorData.address.state_id]);

	useEffect(() => {
		document.title = `${projectTitle} | Pharmnex`;
	}, [projectTitle]);

	const handleUpdateDoctor = async (status) => {
		const checkError = checkValidation();
		if (checkError) {
			toast.error('Please fill all mandatory fields before saving');
		} else {
			setLoading(true);
			var body = {
				doctor_type_id: Number(doctorData.basicDetails.doctor_type_id),
				status: status,
				name: doctorData.basicDetails.doctor_name,
				display_name: doctorData.basicDetails.doctor_display_name,
				business_name: doctorData.basicDetails.business_name,
				email: doctorData.basicDetails.doctor_email,
				phone: doctorData.basicDetails.doctor_phone_work,
				mobile: doctorData.basicDetails.doctor_phone_mobile,
				profile_url: doctorData.basicDetails.profile_url,

				is_enable_portal: doctorData.othersDetails.is_enable_portal,
				registration_number: doctorData.othersDetails.registration_number,

				attention:
					doctorData.address.attention !== '' && doctorData.address.attention !== null
						? doctorData.address.attention
						: '',
				country_id:
					doctorData.address.country_id !== '' && doctorData.address.country_id !== null
						? doctorData.address.country_id
						: '',
				city_id:
					doctorData.address.city_id !== '' && doctorData.address.city_id !== null
						? doctorData.address.city_id
						: '',
				street_1:
					doctorData.address.street_1 !== '' && doctorData.address.street_1 !== null
						? doctorData.address.street_1
						: '',
				street_2:
					doctorData.address.street_2 !== '' && doctorData.address.street_2 !== null
						? doctorData.address.street_2
						: '',
				state_id:
					doctorData.address.state_id !== '' &&
						doctorData.address.state_id !== null &&
						doctorData.address.state_id !== undefined
						? doctorData.address.state_id
						: '',
				zipcode:
					doctorData.address.zip_code !== '' && doctorData.address.zip_code !== null
						? doctorData.address.zip_code
						: '',
			};

			if (doctorDocs.registration_doc) {
				body['registration_doc'] = doctorDocs.registration_doc;
			}
			if (doctorData.doctorRemark.remark_text) {
				body['remarks'] = doctorData.doctorRemark.remark_text;
			}

			const formData = new FormData();
			for (const key in body) {
				formData.append(key, body[key]);
			}
			const jsonType = isEditProfile ? 'multipart/form-data' : 'application/json';

			try {
				const res = await updateDoctor(isEditProfile ? formData : body, id, jsonType);
				if (res?.success) {
					toast.success(res?.message);
					navigate(`/user/${suburl}/doctors`);
				} else {
					toast.error(res?.message || 'Something went wrong');
				}
			} catch (error) {
				toast.error(error?.message || 'Something went wrong');
			} finally {
				setLoading(false);
			}
		}
	};

	useEffect(() => {
		getDoctorDetails();
	}, [id]);

	return (
		<div>
			<Header
				headerTitle="Doctor Details"
				closeButton={{
					showCloseButton: true,
					handler: () => {
						if (isNotEdit) {
							// navigate(`/user/${suburl}/doctors`);
							navigate(-1);
						} else {
							setProjectTitle('Doctor Details');
							getDoctorDetails();
							setIsNotEdit(true);
							setError({});
						}
					},
				}}
				buttons={
					!isNotEdit
						? [
							{
								id: 1,
								className: 'btn-primary mt-0 px-4 ',
								button: 'Save',
								loader: isLoading,
								disabled:
									isLoading ||
									(id
										? !hasPermission('sales.doctors.edit', user?.role?.role_permissions)
										: !hasPermission('sales.doctors.create', user?.role?.role_permissions)),
								handler: () => {
									if (isClone === true) {
										handleCloneDoctor(1);
									} else {
										handleUpdateDoctor(doctorData?.basicDetails?.status);
									}
								},
							},
						]
						: [
							{
								id: 1,
								className: 'btn-primary mt-0 px-4 ',
								button: 'Edit',
								disabled: !hasPermission('sales.doctors.edit', user?.role?.role_permissions),
								handler: () => {
									setProjectTitle('Update Doctor');
									setIsNotEdit(false);
									setActiveTab('Information');
									setError({});
								},
							},
							{
								id: 2,
								disabled: !hasPermission('sales.doctors.clone', user?.role?.role_permissions),
								className: 'btn-gray mt-0 px-4 ',
								button: 'Clone',
								handler: () => {
									setActiveTab('Information');
									setIsNotEdit(false);
									setIsClone(true);
									setDoctorData((prev) => ({
										...prev,
										othersDetails: {
											...prev.othersDetails,
											registration_number: '',
										},
									}));
								},
							},

							{
								id: 3,

								className: 'mt-0 btn-gray add-pro',
								disabled: !hasPermission('sales.doctors.edit', user?.role?.role_permissions),
								button:
									doctorData.basicDetails.status === 0 || doctorData.basicDetails.status === 2
										? 'Mark as Active'
										: 'Mark as Inactive',

								handler: () => {
									setIsMarkAsStatusModel(true);
								},
							},

							{
								id: 5,

								className: 'btn-gray add-pro',
								disabled: !hasPermission('sales.doctors.delete', user?.role?.role_permissions),
								button: 'Delete',

								handler: () => setIsDeleteModalOpen(true),
							},
						].filter(Boolean)
				}
				dropDownButtons={[]}
			/>
			<div style={{ backgroundColor: '#EDEDF7', marginTop: '-10px', paddingLeft: '10px' }}>
				<NavigationTabsDoctor
					activeTab={activeTab}
					setActiveTab={setActiveTab}
				/>
			</div>
			{activeTab === 'Information' && (
				<DoctorForm
					setDoctorData={setDoctorData}
					doctorData={doctorData}
					doctorDocs={doctorDocs}
					setDoctorDocs={setDoctorDocs}
					error={errors}
					setError={setError}
					isEdit={isNotEdit}
					cityList={cityList}
					activeTab={activeFormTab}
					setIsEditProfile={setIsEditProfile}
					setActiveTab={setActiveFormTab}
				/>
			)}
			{activeTab === 'Referral' && <div style={{ padding: '20px' }}>Referral </div>}
			{isMarkAsStatusModel && (
				<ConfirmationModal
					isOpen={isMarkAsStatusModel}
					onClose={() => setIsMarkAsStatusModel(false)}
					title={getModalTitle()}
					content={getModalContent()}
					onCancel={() => setIsMarkAsStatusModel(false)}
					onOk={() => {
						handleIsActiveStatus(
							doctorData.basicDetails.status === 0 || doctorData.basicDetails.status === 2 ? 1 : 2,
						);
					}}
					loader={isLoader}
				/>
			)}

			{isDeleteModalOpen && (
				<DeleteModal
					isDeleteBulkConfirmationModalOpen={isDeleteModalOpen}
					setIsDeleteBulkConfirmationModalOpen={setIsDeleteModalOpen}
					selectedListForDelete={[doctorData.basicDetails.doctor_name]}
					handleBulkDelete={handleBulkDelete}
					deleteLength={1}
					saleTypeName={'Doctor'}
				/>
			)}
		</div>
	);
};
export default DoctorDetails;
